export default __webpack_public_path__ + "static/media/payment-successful.06bb8007.svg";